import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Sidebar from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/Sidebar';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { RightSidebarProvider } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import RightSidebar from 'Views/Page/Content/RightSidebar';
import MainContentPicker from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker';


const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    flexGrow: 1,
    flexBasis: 0,
    flexShrink: 1,
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    maxWidth: 'none',
    position: 'relative',
  },
});

const WhatIfProposalPreviewTemplate = ({
  className,
  classes,
}) => {
  const { pageContentResource, setPageContentCollection } = usePageContentContext();

  return (
    <RightSidebarProvider>
      <Box
        className={classNames(classes.root, className)}
        key={pageContentResource.etag()}
      >
        <Sidebar />
        <MainContentPicker previewResource={pageContentResource} setPreviewCollection={setPageContentCollection} />
        <RightSidebar componentProps={{ title: 'History' }} />
      </Box>
    </RightSidebarProvider>
  );
};

WhatIfProposalPreviewTemplate.defaultProps = {
  className: '',
};

WhatIfProposalPreviewTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WhatIfProposalPreviewTemplate);
